import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { exchangeCollection } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Exchanges{" "}
    <Link className="button" to="/admin/platform/reference/exchange/new">
      New Exchange
    </Link>
  </Fragment>
);

export default function ExchangePage(): ReactNode {
  return (
    <PageLayout title="Reference Platform - Exchange">
      <PaginatedList title={title} collection={exchangeCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Exchange ID</th>
              <th>Exchange Name</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, name }) => (
              <tr key={id}>
                <td>{id}</td>
                <td>{name}</td>
                <td>
                  <Link to={`/admin/platform/reference/exchange/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
